<!-- 用户协议 -->
<template>
	<div class="">
		<CPopup
			v-model="is_show"
			title="隐私协议"
		>
			<div
				style="max-height:50vh;overflow-y:auto;"
				v-html="privacy_policy"
			></div>
		</CPopup>
	</div>
</template>

<script>
import CPopup from "@/components/CPopup.vue"
export default {
	components: { CPopup },
	data() {
		return {
			is_show: false,
			privacy_policy: "", // 隐私政策
		}
	},
	created() {
		this.$eventBus.$on("SHOW_PRIVACY_ARGE", _ => {
			this.is_show = true
		})

		this.$post("v1.index/get_config", { type: 1 }).then(res => { this.privacy_policy = res.data || "" });
	},
	methods: {},
}
</script>

<style lang='scss' scoped></style>